import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import AppHeader from '@/components/AppHeader.vue'

// Vant 组件按需引入
import {
  Toast,
  Button,
  Field,
  Form,
  Icon,
  Image as VanImage,
  Loading,
  Overlay,
  PullRefresh,
  List,
  Cell,
  CellGroup,
  Popup,
  Picker,
  ActionSheet,
  Dialog,
  Stepper,
  Tag,
  Empty,
  Search,
  Tabs,
  Tab,
  NavBar,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  ImagePreview
} from 'vant'
import 'vant/lib/index.css'

// 注册 Vant 组件
const vantComponents = [
  Toast, Button, Field, Form, Icon, VanImage, Loading, Overlay,
  PullRefresh, List, Cell, CellGroup, Popup, Picker, ActionSheet,
  Dialog, Stepper, Tag, Empty, Search, Tabs, Tab, NavBar,
  Tabbar, TabbarItem, Swipe, SwipeItem, ImagePreview
]
vantComponents.forEach(comp => Vue.use(comp))
Vue.component('app-header', AppHeader)

// 挂载 Toast 到全局，方便 this.$toast 调用
// forbidClick: false 避免 toast 触发 body class 变化引起 iOS 滚动跳动
Toast.setDefaultOptions({ forbidClick: false, duration: 1500 })
Vue.prototype.$toast = Toast

// 全局样式
import './styles/global.scss'


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')